var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "promoted-projects" }, [
    _c("div", { staticClass: "hero-image-container" }, [
      _c("img", {
        ref: "mainImage",
        staticClass: "hero-image",
        attrs: {
          src:
            _vm.mainPhoto && _vm.mainPhoto.objectUrl
              ? _vm.mainPhoto.objectUrl
              : require(`@/drc/assets/images/default-project-image.webp`),
          alt: "hero image"
        },
        on: { error: _vm.setFallback }
      }),
      _c("img", {
        ref: "backgroundImage",
        staticClass: "hero-image-background",
        attrs: {
          src:
            _vm.nextPhoto && _vm.nextPhoto.objectUrl
              ? _vm.nextPhoto.objectUrl
              : require(`@/drc/assets/images/default-project-image.webp`),
          alt: "background"
        },
        on: { error: _vm.setFallback }
      }),
      _c("div", { staticClass: "actions-promoted" }, [
        _c("div", { staticClass: "project-data-container" }, [
          _c("img", {
            staticClass: "right-arrow arrow",
            class:
              _vm.currentIndex === _vm.projects.length - 1 ? "disabled" : "",
            attrs: {
              src: require("@/drc/assets/icons/arrows/arrow_right_blue.svg")
            },
            on: { click: _vm.increaseIndex }
          }),
          _c("img", {
            staticClass: "left-arrow arrow",
            class: _vm.currentIndex === 0 ? "disabled" : "",
            attrs: {
              src: require("@/drc/assets/icons/arrows/arrow_right_blue.svg")
            },
            on: { click: _vm.decreaseIndex }
          }),
          _c("p", [_vm._v(_vm._s(_vm.projectIndustry))]),
          _c("h1", [_vm._v(_vm._s(_vm.projectTitle))]),
          _c(
            "div",
            {
              staticClass: "dive-in-button",
              on: {
                mouseenter: _vm.stopShuffle,
                mouseleave: _vm.startShuffle,
                click: function($event) {
                  return _vm.openUrl()
                }
              }
            },
            [_vm._v(" " + _vm._s(_vm.$t("homePage.diveIn")) + " ")]
          )
        ]),
        _c("div", { class: ["featured-stories", { top: _vm.isOnTop }] }, [
          _c("span", [_vm._v(_vm._s(_vm.$t("homePage.featuredStories")))])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }